import React, { useState } from 'react';
import { Dialog, DialogContent } from '../ui/dialog';
import { BACKEND_URL } from './equipmentMeta';

export const PhotoStrip = ({ photos, testid }) => {
  const [open, setOpen] = useState(null);
  if (!photos?.length) return null;
  return (
    <>
      <div className="flex gap-1.5 overflow-x-auto pb-1" data-testid={testid}>
        {photos.map((p) => (
          <button type="button" key={`${p.store}-${p.id}`} onClick={() => setOpen(p)} data-testid={`${testid}-${p.id}`}
            className="w-14 h-14 shrink-0 rounded border border-[#262626] overflow-hidden hover:border-[#D4AF37]">
            <img src={`${BACKEND_URL}${p.url}`} alt={p.category || 'equipment'} className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="bg-[#0A0A0A] border-[#262626] max-w-2xl p-2" data-testid={`${testid}-viewer`}>
          {open && <img src={`${BACKEND_URL}${open.url}`} alt="equipment" className="w-full max-h-[80vh] object-contain" />}
          {open && <p className="text-[11px] text-[#A3A3A3] px-1">{(open.category || '').replace(/_/g, ' ')}{open.uploaded_by ? ` · ${open.uploaded_by}` : ''}{open.caption ? ` · ${open.caption}` : ''}</p>}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PhotoStrip;
